import Axios from 'axios'
import { constants } from '@/config/constant'

const tableFAQ = async (context, payload) => {
    const url = constants.base_url + '/v1/faq/table'
    let response = await Axios.get(url, {headers:{'custom_loading': true}, params: payload})

    if(response.data.status){
        context.commit('SET_FAQ_TABLE', response.data)
    }

    return response.data
}

const createFAQ = async (context, payload) => {
    const url = constants.base_url + '/v1/faq/create'
    let response = await Axios.post(url, payload, {headers:{'Content-Type': 'multipart/form-data'}})

    return response.data
}

const updateFAQ = async (context, payload) => {
    const url = constants.base_url + '/v1/faq/update/' + payload.id
    let response = await Axios.patch(url, payload.data)

    return response.data
}

const deleteFAQ = async (context, payload) => {
    const url = constants.base_url + '/v1/faq/delete/' + payload
    let response = await Axios.delete(url)

    return response.data
}

const resetFAQForm = async (context) => {
    context.commit('RESET_FAQ_FORM')
}

export {
    tableFAQ ,
    createFAQ,
    updateFAQ,
    deleteFAQ,
    resetFAQForm,
}